import React from "react";
import { aboutCopy } from "../../data/site";
export function AboutSection() {
  return <section id="about" className="scroll-mt-20 bg-brgreen py-24 text-cream md:py-32" data-id="element-346" data-mp="1hwa3h27eg83n">
      <div className="mx-auto max-w-[1400px] px-5 md:px-8" data-id="element-347" data-mp="1d5tq1i3kwmha">
        <p className="border-t-2 border-sun pt-5 text-[12px] font-bold uppercase tracking-wide text-sun" data-id="element-348" data-mp="1d48vvtl6f5jy">About</p>
        <h2 className="mt-6 max-w-[14ch] font-display text-[clamp(3rem,8vw,7.5rem)] uppercase leading-[0.92] tracking-tight" data-id="element-349" data-mp="192duyq75qu6p">
          {aboutCopy.headline}
        </h2>

        <div className="mt-14 grid gap-10 md:mt-20 md:grid-cols-[minmax(0,1.1fr)_minmax(0,1fr)] md:gap-16" data-id="element-350" data-mp="z5iui1rbqjps">
          <p className="text-[clamp(1.35rem,2.2vw,1.9rem)] font-semibold leading-snug text-sun" data-id="element-351" data-mp="u7ppvd5o5xrm">{aboutCopy.lead}</p>
          <div className="space-y-6 text-[17px] leading-relaxed text-cream/85" data-id="element-352" data-mp="q7p5zczswud6">
            {aboutCopy.body.map(para => <p key={para} data-id="element-353" data-mp="2kjwua7hmaczz">{para}</p>)}
          </div>
        </div>
      </div>
    </section>;
}